export default __webpack_public_path__ + "static/media/tk.2752f426.svg";